import {
  GROUP_FETCHED,
  GROUPS_FETCHED,
  GROUP_DELETED,
} from 'constants/actions';
import apiClient from 'helpers/api-client';

function groupFetched(group) {
  return {
    type: GROUP_FETCHED,
    group,
  };
}

function groupsFetched(groups) {
  return {
    type: GROUPS_FETCHED,
    groups,
  };
}

function groupDeleted(groupId) {
  return {
    type: GROUP_DELETED,
    groupId,
  };
}

function createGroup(data) {
  return (dispatch, getState) => {
    const state = getState();
    const companyId = state.user.company_id;
    return apiClient
      .post(`companies/${companyId}/groups`, { group: data })
      .then((group) => {
        dispatch(groupFetched(group));
        return group;
      });
  };
}

function updateGroup(groupId, data) {
  return (dispatch) => {
    return apiClient
      .put(`/groups/${groupId}`, { group: data })
      .then((group) => {
        dispatch(groupFetched(group));
        return group;
      });
  };
}

function deleteGroup(groupId) {
  return (dispatch) => {
    return apiClient.delete(`/groups/${groupId}`).then(() => {
      dispatch(groupDeleted(groupId));
      return groupId;
    });
  };
}

function fetchGroup(groupId, force = true) {
  return (dispatch, getState) => {
    if (!force) {
      const state = getState();
      return state.groups.groupsById[groupId];
    }

    const path = `groups/${groupId}`;
    return apiClient.get(path).then((group) => {
      dispatch(groupFetched(group));

      return group;
    });
  };
}

function fetchGroups() {
  return (dispatch, getState) => {
    const state = getState();
    const companyId = state.user.company_id;
    const path = `companies/${companyId}/groups`;
    return apiClient.get(path).then((groups) => {
      dispatch(groupsFetched(groups));

      return groups;
    });
  };
}

export { createGroup, updateGroup, deleteGroup, fetchGroup, fetchGroups };
